// Înregistrare Service Worker pentru PWA
export function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Când noul service worker preia controlul, reîncarcă o singură dată
      // ca pagina să ruleze imediat codul nou (fără să întrebe utilizatorul).
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      navigator.serviceWorker
        .register('/service-worker.js')
        .then(registration => {
          console.log('SW înregistrat:', registration.scope);

          // Verifică periodic dacă există o versiune nouă (la fiecare oră + la revenirea în app)
          setInterval(() => registration.update(), 60 * 60 * 1000);
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') registration.update();
          });

          // Când se găsește o versiune nouă, activeaz-o automat (fără confirm).
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Auto-update: spune noului worker să preia imediat controlul;
                // 'controllerchange' de mai sus va reîncărca pagina o dată.
                newWorker.postMessage('SKIP_WAITING');
              }
            });
          });
        })
        .catch(err => {
          console.log('SW înregistrare eșuată:', err);
        });
    });
  }
}
